import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'

import { ErrorBoundaryProps } from './ErrorBoundary.types'

export default function ErrorBoundary({
  renderOnError,
  children
}: ErrorBoundaryProps) {
  return (
    <ReactErrorBoundary fallbackRender={({ error }) => renderOnError(error)}>
      {children}
    </ReactErrorBoundary>
  )
}
